module.exports = __webpack_public_path__ + "img/cover-7.10707749.jpg";